/* unplugin-vue-components disabled */import { render } from "./UserRightManagementSummary.vue?vue&type=template&id=29135af0&scoped=true&ts=true"
import script from "./UserRightManagementSummary.vue?vue&type=script&lang=ts"
export * from "./UserRightManagementSummary.vue?vue&type=script&lang=ts"

import "./UserRightManagementSummary.vue?vue&type=style&index=0&id=29135af0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29135af0"]])

export default __exports__